import { useEffect, useState } from 'react';

import { useUserProfile } from './use-user-profile';

const isModernBrowser = CSS.supports('height: 100svh');
const initialHeight = isModernBrowser ? 'h-svh' : 'h-screen';

export function useScreenHeight() {
  const userProfile = useUserProfile();
  const [screenHeightClass, setScreenHeightClass] = useState(initialHeight);

  useEffect(() => {
    function updateHeight() {
      if (isModernBrowser) {
        setScreenHeightClass(
          userProfile ? 'h-[calc(100svh-theme(height.20))]' : initialHeight,
        );
      } else {
        const height = `${window.innerHeight}px`;

        document.documentElement.style.setProperty('--dynamic-height', height);

        setScreenHeightClass(
          userProfile
            ? 'h-[calc(var(--dynamic-height)-theme(height.20))]'
            : 'h-[var(--dynamic-height)]',
        );
      }
    }

    updateHeight();

    window.addEventListener('resize', updateHeight);

    return () => window.removeEventListener('resize', updateHeight);
  }, [userProfile]);

  return screenHeightClass;
}
